import { connect } from "react-redux";
import moment from "moment/moment";
import React, { useEffect } from "react";

import { Calendar } from "@/features/calendar/Calendar";
import {
  fetchEventTypeOptions,
  fetchPatient,
  fetchPatients,
  initializeCalendar,
  initializeOnBehalfOfProviderPatient,
  initializeProviderAsAdmin,
  initializeProviderAsSelf,
  refetchSchedule,
  updateSelectedDate,
} from "@/redux/actions/calendar";
import { filterCalendarEvents } from "@/features/calendar/utils/general";
import { getQueryParams } from "@/utils/filters";
import { isUserAdmin, isUserPeerOrCM } from "@/utils/authToken";
import Spinner from "@/components/UI/Spinner";
import {
  timeSlotArray,
  transformTimeSlotArray,
} from "@/features/calendar/utils/appointmentPickerUtils";

export const SchedulePageV2 = (props) => {
  const {
    calendarFilters,
    events,
    isInitialized,
    provider,
    selectedScheduleDates,
    unconfirmedEvent,
  } = props.calendar;
  const providerId = props.match.params.providerId ? props.match.params.providerId : null;
  const patientId = getQueryParams("patientId", props.location.search);

  useEffect(() => {
    if (isUserAdmin() && providerId) {
      props.initializeProviderAsAdmin(providerId);
    } else if (isUserPeerOrCM() && providerId && patientId) {
      props.initializeOnBehalfOfProviderPatient(providerId, patientId);
    } else if (!isUserPeerOrCM() && props.profile) {
      props.initializeProviderAsSelf(props.profile);
    }
  }, [props.profile, providerId]);

  useEffect(() => {
    if (isUserPeerOrCM() && patientId) {
      const patient = props.calendar?.patientMap[patientId] || { patient_id: patientId };

      props.fetchEventTypeOptions(provider, patient);
    } else {
      props.fetchEventTypeOptions(provider);
      props.fetchPatients({ searchParams: { providerId: providerId } });
    }
  }, [provider?.providerId, provider?.providerType]);

  useEffect(() => {
    if (!props.profile) {
      return;
    }

    if (!isInitialized) {
      props.initializeCalendar(props.profile);
      // ensures that todays date is initially selected
      // also triggers side effects like getting the current schedule
      props.updateSelectedDate(moment().local());
    } else {
      props.refetchSchedule();
    }
  }, [props.profile]);

  const filteredEvents = filterCalendarEvents(events, calendarFilters);

  if (!props.profile) {
    return <Spinner />;
  }

  return (
    <section className="SchedulePage pt-3 pt-lg-5">
      <Calendar
        daysToDisplay={selectedScheduleDates}
        patientDropdownOptions={props.calendar.patientDropdownOptions}
        schedule={filteredEvents}
        timeSlots={transformTimeSlotArray(timeSlotArray)}
        unconfirmedEvent={unconfirmedEvent}
        workingHours={props.calendar.provider.localAvailability}
      />
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    calendar: state.calendar,
    profile: state.auth.profile,
  };
};

const mapDispatchToProps = {
  fetchEventTypeOptions,
  fetchPatient,
  fetchPatients,
  initializeCalendar,
  initializeOnBehalfOfProviderPatient,
  initializeProviderAsAdmin,
  initializeProviderAsSelf,
  refetchSchedule,
  updateSelectedDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePageV2);
